import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getRegionsAPI = async () => {
  const data = await phpRequest.get("/regions");
  const allRegionsData = data.regions;
  const regionsNamesAndIDs = allRegionsData.map((regionData) => {
    const filteredRegionData = {
      name: regionData.name,
      id: regionData.id,
    };
    return filteredRegionData;
  });
  await localforage.setItem("regions", regionsNamesAndIDs);
};
